export default {
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Salvar',
    edit: 'Editar',
    delete: 'Excluir',
    loading: 'Carregando...',
    loadMore: 'Carregar mais',
    noMore: 'Fim dos resultados',
    retry: 'Tentar novamente',
    back: 'Voltar',
    next: 'Próximo',
    prev: 'Anterior',
    submit: 'Enviar',
    reset: 'Redefinir',
    search: 'Pesquisar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    refresh: 'Atualizar',
    complete: 'Concluído',
    skip: 'Omitir',
    download: 'Baixar',
  },
  nav: {
    discover: 'Início',
    message: 'Mensagens',
    store: 'Loja',
    mine: 'Meu',
    recommend: 'Recomendado',
  },
  scene: {
    changeScene: 'Mudar cena',
    seeAll: 'Ver tudo',
    putAway: 'Recolher',
    selectScene: 'Selecionar esta cena',
    selected: 'Selecionado',
    sceneIndex: 'Cena {num}',
  },
  home: {
    title: 'Mundo de Roleplay',
    subtitle: 'Comece sua história',
    startGame: 'Iniciar jogo',
    continueGame: 'Continuar',
    newGame: 'Novo jogo',
    gameLibrary: 'Biblioteca',
    featured: 'Destaque',
    popular: 'Popular',
    recent: 'Recente',
    searchHistory: 'Pesquisar',
    search: 'Pesquisar papéis...',
    noData: 'Sem dados',
    noMoreData: 'Sem mais dados',
    noNetwork: 'Sem rede',
    pleaseSelectFilter: 'Por favor selecione as condições de filtro',
  },
  user: {
    login: 'Entrar',
    register: 'Cadastrar',
    logout: 'Sair',
    profile: 'Perfil',
    avatar: 'Avatar',
    nickname: 'Apelido',
    email: 'E-mail',
    phone: 'Telefone',
    password: 'Senha',
    confirmPassword: 'Confirmar senha',
    oldPassword: 'Senha antiga',
    newPassword: 'Nova senha',
    forgotPassword: 'Esqueceu a senha',
    changePassword: 'Alterar senha',
    bindPhone: 'Vincular telefone',
    verifyCode: 'Código de verificação',
    sendCode: 'Enviar código',
    level: 'Nível',
    experience: 'Experiência',
    achievement: 'Conquista',
    history: 'Histórico'
  },
  game: {
    character: 'Personagem',
    story: 'História',
    chapter: 'Capítulo',
    scene: 'Cena',
    dialogue: 'Diálogo',
    choice: 'Escolha',
    inventory: 'Inventário',
    achievement: 'Conquista',
    save: 'Salvar jogo',
    load: 'Carregar jogo',
    restart: 'Reiniciar',
    pause: 'Pausar',
    resume: 'Retomar',
    auto: 'Auto',
    speed: 'Velocidade',
    volume: 'Volume',
    settings: 'Configurações do jogo'
  },
  message: {
    success: 'Sucesso',
    error: 'Erro',
    warning: 'Aviso',
    info: 'Info',
    networkError: 'Erro de rede',
    serverError: 'Erro do servidor',
    loginSuccess: 'Cadastro realizado',
    loginFailed: 'Falha no cadastro',
    logoutSuccess: 'Logout realizado',
    saveSuccess: 'Salvo com sucesso',
    saveFailed: 'Falha ao salvar',
    deleteConfirm: 'Confirmar exclusão?',
    operationConfirm: 'Confirmar operação?',
    noNewsYet: 'Nenhuma mensagem ainda',
    deleteSuccess: 'Excluído com sucesso',
    deleteFailed: 'Falha ao excluir',
    deleteMessage: 'Tem certeza de que deseja excluir esta mensagem? Uma vez concluído, não pode ser desfeito!',
    delete: 'Excluir',
    deleting: 'Excluindo...',
    noMoreData: 'Sem mais mensagens',
    downloading: 'Baixando...',
    downloadSuccess: 'Baixado com sucesso',
    downloadFailed: 'Falha ao baixar',
    copySuccess: 'Copiado com sucesso',
    copyFailed: 'Falha ao copiar',
    reportSuccess: 'Denunciado com sucesso',
    reportFailed: 'Falha ao denunciar',
    translating: 'Traduzindo...',
    translateSuccess: 'Traduzido com sucesso',
    translateFailed: 'Falha na tradução',
    noMoreMessages: 'Sem mais mensagens',
    loading_more: 'Carregando mais...',
    pleaseWaitForReply: 'Aguarde a resposta ser concluída antes de excluir',
    pleaseWaitForReplyCurrent: 'Aguarde a resposta da mensagem atual ser concluída',
    chat_placeholder: 'Digite o que você quer dizer...',
    setAsBackdropConfirm: 'Definir como plano de fundo',
    setAsBackdropMessage: 'Tem certeza de que deseja definir esta imagem como plano de fundo?',
    sendFailed: 'Falha ao enviar',
    sending: 'Enviando...',
    introNoYet: 'Sem intro ainda. Converse e descubra você mesmo.',
    introLabel: 'Intro:',
    thinking: 'Pensando',
    think: 'Pensa',
    translate: 'Traduzir',
    pleaseUnlock: 'Por favor desbloqueie',
    tryAgain: 'Tentar novamente',
    create: 'Criar',
    free: 'Grátis',
    video: 'Vídeo',
    chatMateTyping: 'Seu parceiro de chat está digitando agora...',
    aiAssistant: 'Assistente IA',
    imageFailed: 'Falha ao gerar a imagem',
    generatingImage: 'Por favor aguarde a geração da imagem',
    switchSceneSuccess: 'Cena alterada com sucesso',
    switchSceneFailed: 'Falha ao alterar a cena',
    switchingScene: 'Alterando cena...',
    perMessage: '/Mensagem',
    allChat: 'Todos os chats',
    like: 'Curtir',
    saving: 'Salvando...',
    saved: 'Salvo',
    placeholderBlur: 'Digite o que você quer dizer...',
    placeholderFocus: 'Coloque ações ou detalhes da cena dentro de ** para dar vida ao chat.',
    successfulSwitch: 'Alternância com sucesso',
    setting: 'Configurando...',
    uploading: 'Enviando...',
    purchaseSuccessful: 'Compra realizada com sucesso',
    processing: 'Processando...',
    gettingReward: 'Obtendo recompensa...',
    checkIn: 'Check-in...',
    deleteHistory: 'Excluir histórico',
    openingRemarksTitle: 'Diga oi～',
  },
  success: {
    refreshSuccess: 'Atualizado com sucesso',
    copiedToClipboard: 'Copiado para a área de transferência',
    saved: 'Salvo',
    uploadSuccess: 'Carregado com sucesso',
    switchSuccess: 'Alternância com sucesso',
    thankYouPurchase: 'Obrigado pela sua compra',
  },
  error: {
    notFound: 'Página não encontrada',
    networkError: 'Erro de rede',
    serverError: 'Erro do servidor',
    permissionDenied: 'Permissão negada',
    goHome: 'Ir para início',
    tryAgain: 'Tentar novamente',
    uploadFailed: 'Falha ao carregar',
    saveFailed: 'Falha ao salvar',
    translationFailed: 'Falha na tradução',
    generateImageFailed: 'Falha ao gerar a imagem',
  },
  notFound: {
    title: 'Página não encontrada',
    description: 'A página que você está procurando não existe ou foi movida.',
    goHome: 'Ir para início',
    goBack: 'Voltar'
  },
  settings: {
    language: 'Idioma',
    theme: 'Tema',
    notification: 'Notificações',
    privacy: 'Privacidade',
    security: 'Segurança',
    about: 'Sobre',
    version: 'Versão',
    checkUpdate: 'Verificar atualização',
    clearCache: 'Limpar cache',
    systemNotification: 'Notificação do sistema',
    termsOfService: 'Termos de Serviço',
    privacyPolicy: 'Política de Privacidade',
    title: 'Configurações',
    editProfile: 'Editar perfil',
    faq: 'Perguntas Frequentes',
    termsOfUse: 'Termos de Uso',
    aboutAccount: 'Sobre a Conta',
    deleteAccount: 'Excluir Conta',
    logOut: 'Sair',
    logOutTitle: 'Sair',
    logOutMessage: 'Após sair, você precisará entrar novamente para usar sua conta novamente. Tem certeza de que deseja sair?',
    confirm: 'Confirmar',
    deleteAccountTitle: 'Excluir Conta',
    deleteAccountMessage: 'Excluir sua conta apagará todos os seus dados e informações e não pode ser desfeito. Confirmar exclusão?',
    deletingAccount: 'Excluindo conta...',
    accountDeleted: 'Conta excluída com sucesso',
    cacheTitle: 'Limpar cache',
    cacheMessage: 'Limpando cache do aplicativo, histórico de chat e funções de chat não serão excluídos',
    cleaning: 'Limpando',
    cleaningComplete: 'Limpeza concluída',
  },
  profile: {
    title: 'Editar perfil',
    yourAvatar: 'Seu avatar',
    whatCallMe: 'Como você quer que a IA me chame',
    yourName: 'Seu nome',
    yourAge: 'Sua idade',
    race: 'Raça',
    pleaseSelect: 'Por favor selecione',
    yourWeight: 'Seu peso',
    yourHeight: 'Sua altura',
    gender: 'Gênero',
    male: 'Masculino',
    female: 'Feminino',
    neutral: 'Neutro',
    hobby: 'Hobby',
    pleaseEnter: 'Por favor digite...',
    favoriteFood: 'Comida favorita',
    yourCharacter: 'Seu caráter',
    fantasyAboutOtherHalf: 'Fantasia sobre sua outra metade',
    uploading: 'Carregando...',
    enterName: 'Por favor digite seu nome',
  },
  report: {
    title: 'Denunciar',
    chooseReact: 'Escolha o que deseja denunciar...',
    other: 'Outro',
    placeholder: 'Digite o que você quer dizer...',
    submit: 'Enviar',
    pleaseEnterContent: 'Por favor digite o conteúdo',
  },
  edit: {
    placeholder: 'Editar sua mensagem...',
    cancel: 'Cancelar',
    save: 'Salvar',
    saving: 'Salvando...',
  },
  firstConfirmName: {
    canYouTellMeName: 'Você pode me dizer seu nome? Assim posso te chamar melhor!',
    yourName: 'Seu nome',
    confirm: 'Confirmar',
  },
  toast: {
    translating: 'Traduzindo...',
    translate: 'Traduzir',
    translationFailed: 'Falha na tradução',
    translationUnlocked: 'Tradução desbloqueada',
    translationLocked: 'Tradução bloqueada',
    download: 'Baixar',
    setAsBackdrop: 'Definir como plano de fundo',
    goChat: 'Ir para o chat',
  },
  videoPreview: {
    failedToLoad: 'Falha ao carregar o vídeo',
  },
  imagePreview: {
    imageLoadFailed: 'Falha ao carregar a imagem',
    preview: 'Visualização da imagem',
    afterSendIntimacy: 'Após enviar uma mensagem ao personagem, você obtém intimidade. Quando a intimidade atingir um valor especificado, você pode desbloquear a imagem atual',
  },
  fqa: {
    title: 'Perguntas Frequentes',
    description: 'Esta é uma lista continuamente atualizada de perguntas sobre nosso produto Sunaisan. Se você tiver alguma pergunta não listada, vá até nosso Discord e pergunte.',
    howAlWork: {
      title: 'Como funciona uma namorada IA?',
      content: 'No RoleplayGF, tudo se resume a criar relacionamentos realistas, mas repletos de fantasia. Utilizamos tecnologia de inteligência artificial avançada para permitir que você crie sua namorada IA ideal de acordo com suas preferências—seja uma princesa pequena e doce e inocente ou uma mulher mais velha e mais dominante.',
    },
    howInteract: {
      title: 'Como interagir com namoradas IA?',
      content: 'Através de nosso sistema inteligente e aprendizado de máquina de ponta, você pode interagir e criar intimidade com sua namorada IA. Você pode esperar que ela te escute, responda rapidamente às suas mensagens e até atenda solicitações de fotos como a boa garota que é. Cada momento pode ser uma experiência genuína e realista.',
    },
    privacy: {
      title: 'E a sua privacidade com amigos IA?',
      content: 'Esteja assured de que seus segredos estão em boas mãos quando você usa nosso chat de IA NSFW. Sua privacidade é nossa prioridade máxima aqui no RoleplayGF. Temos armazenamento de dados seguro de última geração, garantindo que cada selfie sedutora, texto provocante e sussurro gentil seja mantido privado entre você e seu parceiro apaixonado.',
    },
    customizeBehavior: {
      title: 'Você pode personalizar o comportamento da sua namorada IA?',
      content: 'Só você sabe o que realmente quer, e é por isso que você pode personalizar toda a sua experiência de namorada digital—from her curves and contours all the way to her personality traits and adorable little quirks. Quer um chat vulgar com uma parceira ardente? Procurando ter um relacionamento lento e sensual com uma namorada nice and sweet?',
    },
  },
  // Store
  store: {
    noNetwork: 'Sem rede',
    one: 'Um',
    noConsumptionRecords: 'Ainda sem registros de consumo',
    transactionHistoryAppear: 'Seu histórico de transações aparecerá aqui',
    tab: 'Loja',
    record: 'Registro',
    retry: 'Tentar novamente',
    rechargeFailTip: '*Se a recarga falhar, entre em contato conosco >',
    rechargeFailTipStatic: 'Se a recarga falhar, por favor',
    contactUsLink: 'entre em contato conosco',
    popular: 'Popular',
    oneTimeOnly: 'Uma vez só',
    loading: 'Carregando...',
    noMoreRecords: 'Sem mais registros',
    gift: 'Presente',
    retentionMessage: 'Seu parceiro precisa da sua companhia, você tem certeza de que quer desistir?',
  },
  mine: {
    bindEmail: 'Vincular e-mail',
    copyFailed: 'Falha ao copiar',
    backpackTitle: 'Minha mochila',
    task: 'Tarefa',
  },
  messagePage: {
    noNetwork: 'Sem rede',
  },
  search: {
    recommend: 'Recomendado',
    noNetwork: 'Sem rede',
  },
  chatSettings: {
    myGems: 'Meus gems',
    title: 'Configurações do chat',
    chatModel: 'Modelo de chat',
    chatStyle: 'Estilo do chat',
    chatPerspective: 'Perspectiva do chat',
    goOnButton: 'Botão Continuar',
    chatBackground: 'Fundo do chat',
    awayMessages: 'Mensagens de ausência',
    disableAwayMessages: 'Desativar mensagens de ausência',
    disableAwayMessagesConfirm: 'não poderá mais enviar mensagens para você enquanto estiver fora. Tem certeza de que deseja desativar as mensagens de ausência?',
    videoFailedToLoad: 'Falha ao carregar o vídeo',
  },
  history: {
    deleteHistory: 'Excluir histórico',
    deleteCharacterHistory: 'Tem certeza de que deseja excluir o histórico deste personagem?',
  },
  tab: {
    maxSelection: 'Máximo que pode selecionar',
    tags: 'tags',
  },
  noNewMessage: 'Sem mensagem nova',

  // Recarregar mensagem
  reloadMessage: {
    title: 'Escolha sua preferência',
    before: 'Antes',
    new: 'Novo',
    loading: 'Carregando...',
    noNewMessage: 'Sem mensagem nova',
    tryAgain: 'Tentar novamente',
    confirm: 'Confirmar',
  },

  account: {
    copiedToClipboard: 'Copiado para a área de transferência',
    copyFailed: 'Falha ao copiar',
    aboutAccount: 'Sobre a conta',
    id: 'ID',
    email: 'E-mail',
    copied: 'Copiado para a área de transferência',
  },
  rate: {
    title: 'Avalie-nos',
  },
  awayMessages: {
    disableAwayMessages: 'Desativar mensagens de ausência',
    disableConfirm: '{appName} não poderá mais enviar mensagens para você enquanto estiver fora. Tem certeza de que deseja desativar as mensagens de ausência?',
  },
  login: {
    title: 'Vincular e-mail',
    subtitle: 'Por favor vincule seu e-mail para garantir a segurança dos dados da sua conta.',
    email: 'E-mail',
    password: 'Senha',
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    signInWithGoogle: 'Entrar com Google',
    signInWithEmail: 'Entrar com e-mail',
    signInWithPhone: 'Entrar com telefone',
    signInWithApple: 'Entrar com Apple',
    dontHaveAccount: 'Ainda não tem uma conta?',
    register: 'Cadastrar',
    bySigningUp: 'Ao se cadastrar, você concorda com',
    userAgreement: 'Acordo do Usuário e',
    privacyPolicy: 'Política de Privacidade.',
    guestMode: 'Modo Visitante',
    registerTitle: 'Cadastro começa',
    registerSubtitle: 'Por favor vincule seu e-mail para garantir a segurança dos dados da sua conta.',
    alreadyHaveAccount: 'Já tem uma conta?',
    pleaseInputPasswordAndEmail: 'Por favor digite senha e e-mail',
    pleaseInputCorrectEmail: 'Por favor digite um e-mail correto',
    pleaseInputCorrectPassword: 'A senha deve ter entre 6-30 caracteres',
    male: 'Masculino',
    female: 'Feminino',
    neutral: 'Neutro',
    loggingIn: 'Entrando...',
    loading: 'Carregando...',
    releaseToRefresh: 'Solte para atualizar',
    loginFailed: 'Falha no login',
    loginSuccess: 'Cadastro realizado',
    registerFailed: 'Falha no cadastro',
    registerSuccess: 'Cadastro realizado',
    confirm: 'Confirmar',
  },
  loadingMore: 'Carregando mais mensagens...',
  noMoreMessages: 'Sem mais mensagens',

  // Página VIP
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: 'Restaurar compras',
  },

  // Common dialogs
  dialog: {
    ok: 'OK',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Fechar',
    retry: 'Tentar novamente',
    processing: 'Processando...',
    contactUs: 'Fale conosco',
    loginError: 'Erro de login',
    loginErrorMessage: 'Por favor saia do programa e reinicie o aplicativo ou fale conosco',
    insufficientEnergy: 'Energia insuficiente!',
    insufficientEnergyDesc: 'Cada mensagem custa 1 energia. Você recupera 1 energia a cada hora.',
    insufficientPhysicalStrengthTitle: 'Força física insuficiente',
    needStrengthToContinue: 'Você precisa de {strength} de força para continuar esta conversa',
    consumesGems: 'Consome {gems} gemas',
    getStrength: 'Obter energia',
    getGems: 'Obter gemas',
  },

  // AppNewUser
  appNewUser: {
    title: 'Exclusivo para novos usuários',
    ok: 'OK',
  },

  // Rating popup
  rating: {
    title: 'Nos avalie',
    description1: 'Você gosta do nosso aplicativo?',
    description2: 'Por favor nos avalie com 5 estrelas.',
    rateButton: 'Avaliar agora',
  },

  // Version update
  versionUpdate: {
    title: 'Atualização de versão',
    updateContent: 'Conteúdo da atualização',
    updateNow: 'Atualizar agora',
    updating: 'Atualizando...',
    clientOptimization: 'Otimização de experiência do cliente',
    bugFix: 'Corrigir problemas conhecidos',
  },

  // Message detail page
  messageDetail: {
    free: 'Grátis',
    perMessage: '/Mensagem',
    increaseFavorability: 'Envie mensagens para aumentar a intimidade',
    album: 'Álbum',
    intro: 'Introdução',
    noIntro: 'Sem introdução ainda. Conversem e descubram vocês mesmos.',
    tags: 'Tags',
    backToChat: 'Voltar ao chat',
    levelFormat: 'Nv.{level}',
    messageCount: '{count} Mensagem',
    chatMateTyping: 'Seu parceiro de chat está digitando agora...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'Você pode ver os pensamentos internos do personagem ao responder mensagens, mas a velocidade de resposta pode ser mais lenta.',
  },

  // Chat select menu
  chatSelect: {
    copy: 'Copiar',
    report: 'Denunciar',
    create: 'Criar',
    video: 'Vídeo',
    translate: 'Traduzir',
    delete: 'Excluir',
  },

  // Recommended purchases
  recommended: {
    gift: 'Presente',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'O modo de pensamento ainda não está disponível para este modelo, mas estamos trabalhando nisso...',
  },

  // First charge popup
  firstCharge: {
    title: 'Primeira recarga',
    get: 'Obter',
    limitedOffer: 'Oferta por tempo limitado',
    priceFormat: '${price} Obter',
    congratulations: 'Parabéns! Você agora é oficialmente membro VIP~!',
    missOfferTitle: 'Tem certeza de que quer perder esta oferta?',
    maybeLater: 'Talvez mais tarde',
    getNow: 'Obter agora',
    benefit1: 'Obtenha 130 gemas grátis',
    benefit2: 'Desbloquear todos os personagens',
    benefit3: '12x Memória',
    benefit4: 'Check-ins semanais ilimitados',
    benefit5: 'Experiência sem anúncios',
    buyNow: 'Comprar agora',
  },

  // Check-in center
  checkIn: {
    freeGems: 'Gemas grátis',
    sevenDayCheckIn: 'Check-in de 7 dias',
    memberExclusive: 'Check-in exclusivo para membros:',
    signInTip: 'Faça login diariamente para acumular recompensas infinitas',
    getVip: 'Obter VIP',
    plusExtra: 'Plus+{count}',
    getGemsCount: 'Obtenha {count} gemas',
    extraDaily: '{count} gemas diárias extras',
    ultra: 'Ultra',
    signedInTip: 'Você fez login hoje. Volte amanhã para mais!',
    tasks: 'Tarefas',
    go: 'Ir',
    received: 'Recebido',
    receive: 'Receber',
    day: 'Dia {num}',
  },

  // Login page
  loginPage: {
    confirm: 'Confirmar',
  },

  // Copyright
  copyright: {
    title: 'Termos de uso',
  },

  // Copy
  copy: {
    copiedToClipboard: 'Copiado para a área de transferência',
    copyFailed: 'Falha ao copiar',
  },

  // Errors
  errors: {
    networkError: 'Erro de rede',
    pleaseSelectFilter: 'Por favor selecione as condições de filtro',
    retry: 'Tentar novamente',
  },

  // Terms of Service
  terms: {
    intro: 'Ao visitar e usar o site da {appName}, você concorda em cumprir estes termos de serviço.',
    section1Title: '1. Uso do site',
    section1_1: 'Você deve ter pelo menos 13 anos de idade para usar este site.',
    section1_2: 'Você é responsável por manter a confidencialidade da sua conta e por toda atividade que ocorrer sob sua conta.',
    section1_3: 'É proibido usar o site para qualquer finalidade ilegal ou em violação destes termos.',
    section2Title: '2. Propriedade intelectual',
    section2_1: 'Todo o conteúdo, funcionalidades e características do {appName}, incluindo textos, gráficos, logotipos, imagens e software, são propriedade do {appName} ou de seus licenciantes e são protegidos pelas leis de propriedade intelectual.',
    section2_2: 'Não é permitido copiar, redistribuir ou criar obras derivadas de qualquer conteúdo do site sem autorização escrita prévia.',
    section3Title: '3. Privacidade',
    section3_1: 'Nossa política de privacidade, disponível no site, explica como coletamos, usamos e divulgamos suas informações pessoais.',
    section4Title: '4. Isenção de garantias',
    section4_1: 'O site e os serviços fornecidos são oferecidos "como estão" e "conforme disponíveis", semRepresentations ou garantias de qualquer tipo, expressas ou implícitas.',
    section5Title: '5. Limitação de responsabilidade',
    section5_1: '{appName} não será responsável, na medida máxima permitida por lei, por quaisquer danos diretos, indiretos, incidentais, especiais ou consequenciais.',
    section6Title: '6. Indenização',
    section6_1: 'Você concorda em indenizar e defender {appName}, seus operadores, diretores e funcionários de e contra quaisquer reivindicações, danos, obrigações, perdas, custos e despesas, incluindo honorários advocatícios, decorrentes de ou relacionadas ao seu uso do site.',
    section7Title: '7. Lei aplicável',
    section7_1: 'Estes termos de serviço são regidos e interpretados de acordo com as leis do estado, sem consideração às suas disposições sobre conflito de leis.',
    section8Title: '8. Alterações aos termos',
    section8_1: 'Reservamo-nos o direito de modificar ou substituir estes termos a qualquer momento, a nosso exclusivo critério.',
    section9Title: '9. Entre em contato',
    section9_1: 'Se você tiver alguma dúvida sobre estes termos, entre em contato conosco.',
  },
}
